<script lang="ts">
/*
Date Picker- should return/ fire event when date has been picked.
Originally default date picker element

should take a potential date as input to set, or just pick today

has to be int he format: "1964-04-20" / YYYY- MM - DD
*/
import { defineComponent, nextTick } from 'vue'
export default defineComponent({

async mounted()
{
    // console.log("DatePicker date_in: ",this.date_in," date test",  this.date_test);
    // if(this.date_in=="1963-04-20")
    //     this.date_s=this.date_in;
    // else
    // {
        // let date= new Date();
        // this.date_s = date.toLocaleDateString('en-us')
        this.date_s = this.ChangeDateToRequiredStringFormat(this.date_in);
        // this.date_s  = date.toISOString().split('T')[0]
        // console.log("<date: today ", this.date_s)
    // }

    // this.date_s="1964-04-20";
    // console.log("<date: ", this.date_s, "this.date_in", this.date_in)
    // nextTick(() =>{
    //     console.log("next tick, DatePicker date_in: ",this.date_in);
    //   });
    
},
props:
{
    date_in:{type:Date, default:new Date()},
    date_test:{type:String},
    onDateChanged:{type:Function, default:(date:Date)=>{console.log("Date changed, default function ", date)}},
},
data() {
        return {
        // icon:{ type:String, default:"home"},

        date_s:"1963-04-20",
        date_selected:new Date()

        };
    },
    //computed- so we can pass variables into css without having to do javascript
    //from: https://stackoverflow.com/questions/42872002/in-vue-js-component-how-to-use-props-in-css
    computed: {
  },
  methods:
  {
    ChangeDateToRequiredStringFormat(date:Date)
    {
        //month is 0 based, but day is not...
        return date.getFullYear() +"-"+this.AddZeroToDate(date.getMonth()+1)+"-"+this.AddZeroToDate(date.getDate());
    },
    AddZeroToDate(num:number)
    {
        let str:string=num.toString();
        if(num<10)
            str="0"+str
        return str;

    },
    DateChanged()
    {
        let date_str = (this.$refs.date_input as HTMLInputElement).value;
        console.log("Date changed: ", date_str);
        this.date_selected = new Date(date_str)
        //for some reason, 1 day off the one you select...
        this.date_selected.setDate(this.date_selected.getDate()+1);

        //also add back in hours, mins, secs from date_in
        //also set the day/ month/ year from date in
        this.date_selected.setHours(this.date_in.getHours());
        this.date_selected.setMinutes(this.date_in.getMinutes());
        this.date_selected.setSeconds(this.date_in.getSeconds());
        this.date_selected.setMilliseconds(this.date_in.getMilliseconds());

        console.log("Date changed: to ", this.date_selected);
        this.onDateChanged(this.date_selected);
    },
    

  },
  watch : {
        date_in:function(date_in) {
            // console.log("watch date_in start called");
                  this.date_s = this.ChangeDateToRequiredStringFormat(date_in);
               }
            },
});
</script>

<template>
    <!-- <p>DateTime date in: {{date_in}}</p> --> <!-- so need to watch when the prop changes, and update the data value-->
    <input :value="date_s" type="date" @change="DateChanged" ref="date_input" required/><!-- required gets rid of clear button-->
</template>

<style scoped>
input
{
    font-size:20px;
    font-family:'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
    background-color: var(--color-background-soft);
    color: var(--color-heading);
    padding: 5px;
    color-scheme: dark;
    border: 1px solid var(--accent-color2);
}
@media only screen and (max-device-width: 460px)
{
    input
    {
        /* font-size:22px; */
    }
}


</style>